export default {
  namespaced: true,
  state: {
    knownCharacters : [],

    isOpenCharacterDetailModal    : false,
    currentSelectedModalCharacter : null,
  },

  mutations: {
    addCharacter(state, payload){
      state.knownCharacters.push(payload);
    },

    updateCharacter(state, payload){
      state.knownCharacters[payload.index] = payload.character;
    },

    isExistsCharacter(state, payload){
      for(let i = 0; i < state.knownCharacters.length; i++){
        if(state.knownCharacters[i].id === payload.id){
          return i;
        }
      }

      return null;
    },

    setIsOpenCharacterDetailModal(state, payload){
      state.isOpenCharacterDetailModal = payload;
    },

    setCurrentSelectedModalCharacter(state, payload){
      state.currentSelectedModalCharacter = payload;
    },

    resetStore(state){
      state.knownCharacters               = [];
      state.isOpenCharacterDetailModal    = false;
      state.currentSelectedModalCharacter = null;
    }
  },

  actions: {
    getCharacterFromName(context, payload){
      for(let i = 0; i < context.state.knownCharacters.length; i++){
        if(context.state.knownCharacters[i].name === payload.characterName){
          return context.state.knownCharacters[i];
        }
      }

      return null;
    },

    getCharacter(context, payload){
      for(let i = 0; i < context.state.knownCharacters.length; i++){
        if(context.state.knownCharacters[i].id === payload.characterId){
          return context.state.knownCharacters[i];
        }
      }

      // ここまで来たら知らないキャラクター情報なので取得したい。

      return null;
    },

    setCharacter(context, payload){
      let isExists = null;

      for(let i = 0; i < context.state.knownCharacters.length; i++){
        if(parseInt(context.state.knownCharacters[i].id) === parseInt(payload.character.id)){
          isExists = i;
          break;
        }
      }

      if(isExists === null){
        context.commit('addCharacter', payload.character);
      }else{
        context.commit('updateCharacter', {
          index     : isExists,
          character : payload.character,
        });
      }
    },

    setIsOpenCharacterDetailModal(context, payload){
      context.commit('setIsOpenCharacterDetailModal', payload);
    },

    setCurrentSelectedModalCharacter(context, payload){
      context.commit('setCurrentSelectedModalCharacter', payload.character);
    },

    resetStore(context){
      context.commit('resetStore');
    }
  }
};
